module.exports = __webpack_public_path__ + "img/253C3C_528181_406C6C_385F5F-256px.3ea3e07b.png";